import script from "./ToggleField.vue?vue&type=script&setup=true&lang=js"
export * from "./ToggleField.vue?vue&type=script&setup=true&lang=js"

import "./ToggleField.vue?vue&type=style&index=0&id=6399655e&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6399655e"]])

export default __exports__